import { EntityTableOptions, EntityTablePagePartialProps, MenuActionId } from "@crispico/foundation-react";
import { ReduxReusableComponents, RRCProps } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { FlightTablePage, FlightTablePageOptions, FlightTablePageReducers, FlightTablePageState } from "pages/flight/FlightTablePage";
import { EntityTableSimpleDnDCellProps, EntityTableSimpleDnDCellRRC } from "./EntityTableSimpleDnDCell";
import { EntityTablePageWithGanttState } from "./EntityTablePageWithGantt";
import { XopsGanttPartialProps } from "./EntityTablePageWithGantt";
import { RealTimeEmbeddedTableMixin } from "./RealTimeEmbeddedTableBase";
import { Task } from "types";

const BaseClass = RealTimeEmbeddedTableMixin(FlightTablePage);

export class RealTimeFlightEmbeddedTableState extends FlightTablePageState {
    protected static readonly defaultOptions: FlightTablePageOptions = {
        ...EntityTablePageWithGanttState.defaultOptions,
        expandTasks: true,
        showGantt: true,
        compactMode: true,
    };
    protected static readonly localStorageKey: string = 'RealTimeFlightEmbeddedTable.options';
}
export class RealTimeFlightEmbeddedTableReducers<S extends RealTimeFlightEmbeddedTableState = RealTimeFlightEmbeddedTableState> extends FlightTablePageReducers<S> {
}

export type RealTimeFlightEmbeddedTableProps = { getFullEntity?: (entityName: string, entity: any) => any; showFlightFilterComponent?: boolean; onRefresh?: () => Promise<void> } & EntityTablePagePartialProps & RRCProps<RealTimeFlightEmbeddedTableState, RealTimeFlightEmbeddedTableReducers>;

export class RealTimeFlightEmbeddedTable extends BaseClass<RealTimeFlightEmbeddedTableProps> {

    static defaultProps = {
        ...FlightTablePage.defaultProps,
        showFlightFilterComponent: false,
        embeddedMode: true,
    }

    constructor(props: RealTimeFlightEmbeddedTableProps) {
        super(props);
        this.tableSimpleClass = EntityTableSimpleDnDCellRRC as any;
    }

    // override the super to load more, otherwise the HRS gantt will not have flight & task info for the mission items
    _options: EntityTableOptions = { bulkSize: 1000, rowOffsetStartLoadingBulk: 900, countMode: true };

    setDate(date: string | null) {
        this.props.r.setInReduxState({ options: { ...this.props.s.options, date: date } });
    }

    protected getTableSimpleProps(): Partial<EntityTableSimpleDnDCellProps> | undefined {
        return {
            ...super.getTableSimpleProps(),
            onDrop: this.xopsGanttRef.current?.onDrop,
            "data-testid": "RealTimeFlightEmbeddedTable"
        };
    }

    protected getXopsGanttProps(): XopsGanttPartialProps {
        return {
            ...super.getXopsGanttProps(),
            activatedDnD: true
        }
    }

    protected showInMenu(key: MenuActionId) {
        return true;
    }

    async superRefresh() {
        console.log("refresh flights");
        return super.refresh();
    }

    async componentDidMount() {
        super.componentDidMount();
        // needed because we want to trigger the loading data for embeddedMode
        // this.refresh();
    }

    async refresh() {
        if (this.props.onRefresh) {
            await this.props.onRefresh();
        } else {
            await this.superRefresh();
        }
    }

    getTasks(missionId: any): Task[] {
        const entities = this.entityTableSimpleRef.current?.getEntities();
        if (!entities) {
            return [];
        }
        const tasks: Task[] = [];
        for (const flight of entities) {
            if (flight.tasks && Array.isArray(flight.tasks)) {
                for (const task of flight.tasks) {
                    if (task.mission?.id === missionId) {
                        tasks.push({ ...task, taskGroup: flight });
                    }
                }
            }
        }
        return tasks;
    }

    render() {
        return super.renderMain();
    }
}

export const RealTimeFlightEmbeddedTableRRC = ReduxReusableComponents.connectRRC(RealTimeFlightEmbeddedTableState, RealTimeFlightEmbeddedTableReducers, RealTimeFlightEmbeddedTable);
